import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import avatar from '../assets/images/avatar.png';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/ziauddin-sayyed" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://in.linkedin.com/in/sayyed-ziauddin-24aab67a" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Sayyed Ziyauddin</h1>
          <p>Software Developer</p>
          <a href="mailto:sayyedzia5@gmail.com?subject=Hi Sayyed&body=Please contact.">sayyedzia5@gmail.com</a><br />
          <a href="tel:+917208649034">+917208649034</a>

          <div className="mobile_social_icons">
            <a href="https://github.com/ziauddin-sayyed" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://in.linkedin.com/in/sayyed-ziauddin-24aab67a" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;